import React, { useState } from 'react';
import LocationPopup from '../../common/Utils/LocationPopup/LocationPopup';
import styles from "./MapLocationButton.module.scss";
import { Tooltip, IconButton } from '@mui/material';
import { useTranslation } from "react-i18next";
import Icon from '../Icon/Icon';
const MapLocationButton = ({ orderStatus, orderId, latitude, longitude, addressLine1, addressLine2, city, state, zipcode, country, arrivalTime, estimatedArrivalTime, exceptedArrivalTime, exceptedExitTime, siteLocalTime, isDelayed, pageName }) => {
    const { t } = useTranslation();
    const [openLocationPopup, setOpenLocationPopup] = useState(false);
    const location = {
        lat: parseFloat(latitude),
        lng: parseFloat(longitude)
    }
    const addressDetails = {
        addressLine1: addressLine1 ? addressLine1 : '',
        addressLine2: addressLine2 ? addressLine2 : '',
        city: city,
        state: state,
        zipcode: zipcode,
        country: country
    };
    return (
        <>
            <Tooltip
                title={
                    <span>
                        {t("PatientsDetails.fulfillmentLocation")}
                    </span>
                }
            >
                <IconButton
                    color="secondary"
                    size={pageName === "globalSearch" ? "small" : "medium"}
                    onClick={() => setOpenLocationPopup(!openLocationPopup)}
                    className={pageName === "globalSearch" ? "marginLeftEight" : ""}
                >
                    <Icon icon="fa-map" />
                </IconButton>
            </Tooltip>
            {openLocationPopup && <LocationPopup orderId={orderId} location={location} orderStatus={orderStatus} openLocationPopup={openLocationPopup} setOpenLocationPopup={setOpenLocationPopup} addressDetails={addressDetails} arrivalTime={arrivalTime} estimatedArrivalTime={estimatedArrivalTime} exceptedArrivalTime={exceptedArrivalTime} exceptedExitTime={exceptedExitTime} siteLocalTime={siteLocalTime} isDelayed={isDelayed} />}
        </>
    )
}

export default MapLocationButton;